import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime';
export const IconArrowLeft = (props) =>
  _jsxs('svg', {
    viewBox: '0 0 24 24',
    fill: 'none',
    ...props,
    children: [
      _jsx('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M4 12a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Z',
        fill: 'currentColor',
      }),
      _jsx('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M10.707 6.293a1 1 0 0 1 0 1.414L6.414 12l4.293 4.293a1 1 0 0 1-1.414 1.414l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 0Z',
        fill: 'currentColor',
      }),
    ],
  });
IconArrowLeft.displayName = 'IconArrowLeft';
